import {findModelContext, isWebMcpEnabled, markAgentRequests} from "@/functions/webMcp";
import {registerGlobalWebMcpTools, registerRouteWebMcpTools, watchDialogs} from "@/functions/webMcpRegistry";

export default {
	install: (app, {router}) => {
		router.afterEach((to, from, failure) => {
			if (!failure) void registerRouteWebMcpTools(to, router)
		})
		if (!isWebMcpEnabled()) return
		void registerGlobalWebMcpTools(router)
		if (!findModelContext()) return
		markAgentRequests()
		watchDialogs(router)
	},
}
